import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ListItem} from '../../classes/list-item.class';

@Component({
  selector: 'app-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: []
})
export class FormSelectComponent implements OnInit {

  @Input() id = '';
  @Input() placeholder = '';
  @Input() label = '';
  @Input() screenReaderText = '';
  @Input() errorMessage = '';
  @Input() form: UntypedFormGroup;
  @Input() items: ListItem[] = [];
  @Input() isSubmitted = false;
  @Input() infoText = '';
  @Input() col = '';

  @Output() selectChange = new EventEmitter();

  @ViewChild('helpFieldBtn') helpFieldBtnElement: ElementRef;

  expanded: boolean;
  helpTexts: string[] = [];

  get formControl() {
    return this.form.get(this.id);
  }

  ngOnInit() {
    this.expanded = false;
    this.helpTexts = [this.infoText];
  }

  isFieldInvalid(): boolean {
    return this.isSubmitted && (this.formControl.invalid && this.formControl.touched);
  }

  onChange(): void {
    this.selectChange.emit(this.formControl.value);
  }

  isInfoTextEmpty(): boolean {
    return this.infoText === undefined || this.infoText === null || this.infoText === '';
  }

  onClose(): void {
    this.expanded = false;
    this.helpFieldBtnElement.nativeElement.focus();
  }

  onOpenAlert() {
    this.expanded = this.toggleAlert();
    return false;
  }

  onKeydownEnter(): void {
    this.expanded = this.toggleAlert();
  }

  onKeydownSpace() {
    this.expanded = this.toggleAlert();
    return false; // Stoppar scroll down
  }

  toggleAlert(): boolean {
    this.expanded = !this.expanded;
    return this.expanded;
  }
}
